export interface ProductsListMapperI {
   select: boolean,
   id: string, 
  'productId': string,
  'inhouseId': string,
  'productName': string,
  "productTypeName": string,
  "productType": string,
  "vendorName": string,
  "storeNames": string,
  "source": string,
  "expirationDate": string,
  "sourceProductSku": string,
  "dateCreated": string,
  "dateModified": string,
  "catalogYear": string,
  "poType": string,
  "categoryName":string,
  "productOrderType":string,
  "assignedUserName":string;
  "calculatorType":string;
  "specialPrice":string;
  "prodStatus": string;
  "msrp": string;
  "countryOrigin": string;
  "customerName": string;
  "manufacturerName": string;
  "prodKind": string;
  "productChannel": string;
  "autoPullEvents": string;
  "productionTime": string;
}
